<template>
  <v-dialog
    :value="dialogVisible"
    :content-class="dialogSize + ' group-dialogs'"
    :retain-focus="false"
    max-width="640px"
    @input="closeModal"
  >
    <component
      :is="dialogComponent"
      :typeId="groupId"
      :group="group"
      :folderId="value.folderId"
      type="bookmark"
      threadId="sms"
      @close="closeModal"
      modal
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupActionsModal',
  props: {
    value: {
      type: Object,
      default: () => ({
        group: null,
        type: null,
        folderId: null,
      }),
    },
  },
  computed: {
    ...mapGetters(['singleGroup']),
    groupId() {
      return this.value?.group?.id ?? null;
    },
    group() {
      return this.singleGroup(this.groupId);
    },
    dialogName() {
      return this.value?.type || '';
    },
    dialogVisible() {
      return !!this.value.type;
    },
    dialogSize() {
      const mdSizeFor = ['GroupAddToCampaignDialog', 'GroupSettingsDialog'];
      if (mdSizeFor.includes(this.dialogName)) {
        return 'fixed-height-md';
      }
      return 'fixed-height-lg';
    },

    // for some reason import doesn't work
    // if set path as variable like import(`${path}${componentName}`)
    dialogComponent() {
      if (this.dialogName.startsWith('Group')) {
        return () => import(`@/views/groups/dialogs/${this.dialogName}`);
      }

      if (this.dialogName === 'ContactsExport') {
        return () => import('@/views/contacts/components/ContactsExport');
      }

      if (this.dialogName === 'ConversationsChat') {
        return () => import('@/views/conversations/chat/ConversationChat');
      }

      if (this.dialogName === 'ConversationsEmail') {
        return () => import('@/views/conversations/helpers/CreateEmailModal');
      }

      return '';
    },
  },
  methods: {
    closeModal() {
      this.$emit('input', {
        group: null,
        type: null,
      });
    },
  },
};
</script>

<style>
.group-dialogs {
  background-color: var(--v-light-base);
}
</style>
